<template>
    <infinite-scroller-vertical @scrolledTillBottom="reachedBottom" :windowTarget="false">
        <v-list>
            <user-list-item v-for="user in likedUsers" :key="user.id" :userDetail="user"></user-list-item>
            <template v-if="likesLoading">
                <v-skeleton-loader type="list-item-avatar-two-line" v-for="n in 3" :key="'skeleton-user-loader-' + n"></v-skeleton-loader>
            </template>
        </v-list>
    </infinite-scroller-vertical>
</template>
<script>
import {
    GET_LIKED_LIST
} from "@/store/actions.type"
import {
    CLEAR_LIKED_USERS
} from "@/store/mutations.type"
import userListItem from "@/components/list-item/list-item-user.vue"
export default {
    components: {
        'user-list-item': userListItem
    },

    props: {
        postId: Number
    },

    data: () => ({
        likesLoading: false,
    }),

    computed: {
        likedUsers() {
            return this.$store.state.post.likedUsers
        }
    },

    created() {
        this.fetchLikes()
    },

    methods: {
        fetchLikes() {
            if (!this.likesLoading && !this.$store.state.post.likedUsersFetchCompleted) {
                this.likesLoading = true
                this.$store.dispatch(GET_LIKED_LIST, {
                        postId: this.postId
                    })
                    .then(() => {
                        this.likesLoading = false
                    })
                    .catch(() => {
                        this.likesLoading = false
                    })
            }

        },

        reachedBottom(val) {
            if (val) {
                this.fetchLikes()
            }
        }
    },

    destroyed() {
        this.$store.commit(CLEAR_LIKED_USERS)
    }
}
</script>